import { historicoSubsectionStyles } from '@atendimento/detail/historico/model/model-historico'
import { Heading, HFlow, VFlow } from 'bold-ui'
import { MChatMarca } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/components/MChatMarca'

import { MChat } from '../../consulta/HistoricoObjetivoPecPanel'
import { HistoricoMChatRfTableBox } from './HistoricoMChatRfTableBox'
import { HistoricoMChatTableBox } from './HistoricoMChatTableBox'

interface HistoricoMChatPanelProps {
  mChats?: ReadonlyArray<MChat>
  idadeEmMeses: number | undefined
}

export function HistoricoMChatPanel(props: Readonly<HistoricoMChatPanelProps>) {
  const { mChats, idadeEmMeses } = props

  if (!mChats || mChats.length === 0) {
    return null
  }

  return (
    <VFlow vSpacing={0.5}>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Heading level={3} style={historicoSubsectionStyles.puericultura}>
          M-CHAT-R/F™ (Checklist Modificado para Autismo em Crianças Pequenas)
        </Heading>
        <MChatMarca />
      </HFlow>
      {mChats.map((mChat) =>
        mChat.isMchatRf ? (
          <HistoricoMChatRfTableBox
            key={mChat.id}
            risco={mChat.risco}
            pontuacao={mChat.pontuacao}
            aplicacao={mChat.aplicacao}
          />
        ) : (
          <HistoricoMChatTableBox
            key={mChat.id}
            risco={mChat.risco}
            pontuacao={mChat.pontuacao}
            aplicacao={mChat.aplicacao}
            cidadaoIdadeEmMeses={idadeEmMeses}
          />
        )
      )}
    </VFlow>
  )
}
